import { Injectable } from '@angular/core';
import { Engine, RuleEngineService } from '@cbre/rule-engine';
import { Column } from '@miq/catalog';
import { RecordConfigFacts } from './controls-facts.model';

/**
 * Default rule {@link Engine} implementation with Record, Data, User and config where config
 * can be `Column` | `Section` | `GroupedSection` (with Column as default type)
 *
 */
@Injectable()
export class ControlsRuleEngineService<T = Column>
  extends RuleEngineService<RecordConfigFacts<T>>
  implements Engine<RecordConfigFacts<T>> {}
